console.log("sizesAvailable.js");

/**
 * sizesAvailable.js
 * --------------------------------------------------------------
 * Cuando el usuario marca una TALLA o un COLOR en el filtro, este
 * script marca automáticamente el checkbox de "Disponibilidad /
 * En stock" (si existe y no está ya marcado), disparando el
 * evento change para que el JS del tema procese el filtro tal
 * como si el usuario lo hubiera marcado a mano.
 *
 * Basado en el HTML real confirmado en el inspector:
 *   <input type="checkbox" name="filter.v.option.talla" value="30" ...>
 *
 * NOTA: el name del filtro de color es una suposición razonable
 * (filter.v.option.color). Si al inspeccionar el checkbox de
 * color en el sitio el name real es distinto, solo hay que
 * ajustar el arreglo TRIGGER_SELECTORS de abajo.
 * --------------------------------------------------------------
 */

(function () {
  // Cualquier checkbox que coincida con uno de estos selectores
  // dispara el auto-check de disponibilidad.
  var TRIGGER_SELECTORS = [
    'input[name="filter.v.option.talla"]',
    'input[name="filter.v.option.color"]',
  ];

  // Nombre estándar que usa Shopify para el filtro de disponibilidad.
  // Si en tu tema es distinto, ajústalo aquí (o deja el fallback de abajo).
  var AVAILABILITY_NAME = "filter.v.availability";

  // Palabras para encontrar el checkbox de disponibilidad por su label,
  // por si el name real es distinto al estándar.
  var AVAILABILITY_LABEL_KEYWORDS = ["disponib", "stock", "existenc"];

  function matchesTrigger(el) {
    if (!el.matches) return false;
    return TRIGGER_SELECTORS.some(function (selector) {
      return el.matches(selector);
    });
  }

  function findAvailabilityCheckbox() {
    // 1) Intento directo por name.
    var byName = document.querySelector(
      'input[name="' + AVAILABILITY_NAME + '"]'
    );
    if (byName) return byName;

    // 2) Fallback: buscar por el texto del label asociado a cada checkbox.
    var checkboxes = document.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < checkboxes.length; i++) {
      var checkbox = checkboxes[i];
      var label = checkbox.id
        ? document.querySelector('label[for="' + checkbox.id + '"]')
        : checkbox.closest("label");
      var text = (label ? label.textContent : "").toLowerCase();

      var matches = AVAILABILITY_LABEL_KEYWORDS.some(function (keyword) {
        return text.includes(keyword);
      });
      if (matches) return checkbox;
    }

    return null;
  }

  function handleFilterChange(filterCheckbox) {
    if (!filterCheckbox.checked) return; // solo actuamos al marcar, no al desmarcar

    var availabilityCheckbox = findAvailabilityCheckbox();
    if (!availabilityCheckbox) {
      console.warn(
        "sizesAvailable.js: no se encontró el checkbox de disponibilidad."
      );
      return;
    }

    if (!availabilityCheckbox.checked) {
      availabilityCheckbox.checked = true;
      availabilityCheckbox.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }
  }

  // Delegación a nivel de documento: funciona aunque el tema vuelva a
  // renderizar el bloque de filtros vía AJAX (los checkboxes nuevos
  // igual quedan cubiertos, sin tener que re-enganchar listeners).
  document.addEventListener("change", function (event) {
    var target = event.target;
    if (matchesTrigger(target)) {
      handleFilterChange(target);
    }
  });

  // --------------------------------------------------------------
  // Caso URL directa: cuando se entra con un parámetro tipo
  // ?filter.v.option.color=ANIMAL+PRINT, Shopify renderiza el
  // checkbox ya marcado desde el servidor y NO dispara "change".
  // Por eso revisamos manualmente al cargar si hay algún checkbox
  // de talla/color ya marcado, y si lo hay, procesamos disponibilidad.
  // --------------------------------------------------------------
  function checkAlreadyCheckedFilters() {
    TRIGGER_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (checkbox) {
        if (checkbox.checked) {
          handleFilterChange(checkbox);
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkAlreadyCheckedFilters);
  } else {
    checkAlreadyCheckedFilters();
  }

  // Revisión periódica: el panel de filtros de este tema puede renderizar
  // o marcar sus checkboxes de forma diferida (al abrir el drawer, vía
  // JS interno del tema) sin disparar un evento "change" ni una mutación
  // de DOM que podamos detectar de forma confiable. Por eso, en vez de
  // depender de un evento puntual, revisamos el estado real cada medio
  // segundo. Es una operación muy liviana (recorre un puñado de
  // checkboxes), así que no afecta el rendimiento.
  setInterval(checkAlreadyCheckedFilters, 500);
})();